import axios from "axios";
import React from "react";
import { useState, useEffect } from "react";
import { alert_error, alert_success } from "../../AppContext";
import ToggleButton from "../../app_structure/toggleButton";
import { Cookies } from "../../index.js";
import Select from "react-select";
import Products from '../products/store.jsx';
import { NavLink, Link, useParams } from 'react-router-dom'
import { RiPencilLine } from "react-icons/ri";
import Bannerprofile from "./Bannerprofile";
import History from "./history";
import { RingLoader } from "react-spinners";
const Adsprofiles = () => {
  const { slug_2 } = useParams();
  console.log(slug_2);
  const [showoption, setshowoption] = useState(false);
  const [inputlienket, setinputlienket] = useState("");
  const [urlmuahang, seturlmuahang] = useState("");
  const [code_store, setcode_store] = useState("");
  const [nutxuly, setnutxuly] = useState(0);
  const [shop, setshop] = useState(null);
  const [datatype, setdatatype] = useState("");
  const [datatype2, setdatatype2] = useState("");
  const [service, setservice] = useState("");
  const [iduser, setiduser] = useState(null);
  const [nutorder, setnutorder] = useState("✔️ Click to Confirm");
  const [type, settype] = useState("shop");
  useEffect(() => {
    laythongtin();
    laydulieu();
  }, []);
  function laythongtin() {
    const apikey = Cookies.get("apikey");
    const apidata = {
      apikey: apikey,
      chedo: 'laythongtin',
      dulieu: 'shop',
    }
    const headers = {
      'Content-Type': 'application/json',
    }
    axios
      .post('https://hust.media/api/account.php', apidata, headers)
      .then((response) => {
        setshop(response.data);
        setiduser(response.data.iduser);
        console.log(response.data.iduser);
      })
      .catch((error) => {
        alert_error(error)
      })
  };
  const [options, setOptions] = useState([
    {
      value: 74588,
      label: "Quảng cáo shop",
      text: "1 ngày đặt tối đa 1 lần, app sẽ gửi 1 tin nhắn quảng cáo vô nhóm chat thảo luận hust media, tin nhắn bị xóa sau 1 tiếng",
      placeholder: "Nhập số Views Bạn muốn quảng cáo",
      type: "shop",
    },
    {
      value: 57850,
      label: "Quảng cáo gian hàng",
      text: "Bố trí quảng cáo hiển thị nhiều nơi giúp mọi người biết tới , phí 1 view 1 Coins",
      placeholder: "Nhập số Views Bạn muốn quảng cáo",
      type: "store",
    }

  ]);
  const [selectedOption, setSelectedOption] = useState(options[0]);
  const [services, setServices] = useState([
    {
      value: 57850,
      label: "Đặt Banner tiếp cận nhiều người nhất",
      text: "Bố trí quảng cáo hiển thị nhiều nơi giúp mọi người biết tới , phí 1 view 1 Coins",
      placeholder: "Nhập số Views Bạn muốn quảng cáo",
      type: "orders",
    },
    {
      value: 57851,
      label: "Đặt Banner nâng cao thương hiệu",
      text: "Hiển thị ở những vị trí đẹp , một người sẽ chỉ xem quảng cáo của bạn tối đa trong 2 lần 1 ngày, phí 2 view 1 Coins",
      placeholder: "Nhập số Views Bạn muốn quảng cáo",
      type: "orders",
    },
    {
      value: 74588,
      label: "Quảng cáo lên nhóm",
      text: "1 ngày đặt tối đa 1 lần, app sẽ gửi 1 tin nhắn quảng cáo vô nhóm chat thảo luận hust media, tin nhắn bị xóa sau 2 tiếng",
      placeholder: "Nhập số Views Bạn muốn quảng cáo",
      type: "shorts",
    },
  ]);
  const [groups, setgroups] = useState([
    {
      value: 81243,
      label: "Quảng cáo lên nhóm chính",
      text: "Bố trí quảng cáo hiển thị nhiều nơi giúp mọi người biết tới , phí 1 view 1 Coins",
      serive: "official",
      money: 2500,
    },
    {
      value: 74588,
      label: "Quảng cáo lên nhóm thảo luận",
      text: "Hiển thị ở những vị trí đẹp , một người sẽ chỉ xem quảng cáo của bạn tối đa trong 2 lần 1 ngày, phí 2 view 1 Coins",
      placeholder: "Nhập số Views Bạn muốn quảng cáo",
      serive: "boxchat",
      money: 1500,
    }
  ]);
  function laydulieu() {
    const apikey = Cookies.get("apikey");
    axios
      .post("https://hust.media/getservice/service.php", {
        api_categorymini: "banner",
      })
      .then((response) => nhadichvu(response))
      .catch((error) => alert_error(error));
  }
  function nhadichvu(response) {
    if (response.data) {
      var jsonArray = response.data;
      // Lặp qua mỗi đối tượng trong mảng và thay đổi giá trị của thuộc tính "id"
      for (var i = 0; i < jsonArray.length; i++) {
        jsonArray[i].value = jsonArray[i].id; // Sao chép giá trị từ "id" sang "value"
        delete jsonArray[i].id; // Xóa thuộc tính "id"
      }
      for (var i = 0; i < jsonArray.length; i++) {
        jsonArray[i].label = jsonArray[i].name; // Sao chép giá trị từ "id" sang "value"
        delete jsonArray[i].name; // Xóa thuộc tính "id"
      }
      // In ra mảng JSON sau khi đã thay đổi
      console.log(jsonArray);

      setServices(response.data);
      setshowoption(true)
    }
  };
  function testFunction(response) {
    setnutorder("đặt tiếp luôn nào");
    setnutxuly(0);
    const info = response.data;
    if (info.error) {
      alert_error(info.error);
    } else if (info.order) {
      alert_success(
        "Cảm ơn bạn là người thứ " + info.order + " ủng hộ Hust Media"
      );
    } else {
      alert_error("Đã xảy ra lỗi hệ thống vui lòng liên hệ admin");
    }
    if (info.redirect != null && info.redirect != "") {
      setTimeout(function () {
        // Chuyển hướng sang trang web khác
        window.location.href = info.redirect;
      }, 1700);
    }
  }
  const [isOpen, setIsOpen] = useState(true);
  const [isOpen2, setIsOpen2] = useState(true);
  const handleChange1 = (selectedOption) => {
    setSelectedOption(selectedOption);
    settype(selectedOption.type);
    console.log(selectedOption.type);
    // if (selectedOption.type == 'shorts') {
    //   setinputlienket(1);
    // }
  };
  const handleFocus1 = () => {
    setIsOpen(true);
    console.log(123);
  };
  const handleBlur1 = () => {
    setIsOpen(false);
  };
  const handleMenuOpen1 = () => {
    setIsOpen(true);
  };
  const handleChange2 = (selectedOption) => {
    setIsOpen(false);
    setservice(selectedOption.value);
    setdatatype(selectedOption);
    // console.log(selectedOption);
    if (selectedOption.type == 'shorts') {
      setinputlienket(1);
    }
    else {
      setinputlienket('');
    }
  };
  const handleChange3 = (selectedOption) => {
    setIsOpen2(false);
    console.log(selectedOption.serive);
    setdatatype2(selectedOption);
    setservice(selectedOption.value);
  };
  const handleFocus2 = () => {
    setIsOpen(true);
    console.log(123);
  };
  const handleFocus3 = () => {
    setIsOpen2(true);
    console.log(123);
  };
  const handleBlur2 = () => {
    setIsOpen(false);
  };
  const handleBlur3 = () => {
    setIsOpen2(false);
  };
  const handleMenuOpen2 = () => {
    setIsOpen(true);
  };
  const handleMenuOpen3 = () => {
    setIsOpen2(true);
  };
  function handleSubmit(event) {
    setnutxuly(0);
    const apikey = Cookies.get("apikey");
    const national_market = Cookies.get("national_market");
    event.preventDefault();

    setnutxuly(1);
    setnutorder("Please wait a moment 😊");
    if (!inputlienket) {
      alert("Please điền đầy đủ thông tin");
      setnutxuly(0);
      setnutorder("điền đủ thông tin");
      return;
    }
    axios
      .post("https://hust.media/api/v3", {
        action: "add",
        key: apikey,
        service: service,
        quantity: inputlienket,
        typeads: type,
        code_store: code_store,
        urlmuahang: urlmuahang,
        national_market: national_market,
        link: "Quảng cáo Hust Media"
      })
      .then((response) => testFunction(response))
      .catch((error) => alert_error(error));
  }
  return (
    <>
      <div className="mx-auto mt-0  max-w-2xl  items-center justify-center">
        Quảng cáo mẫu
        <Bannerprofile chedo={"demo"} />
      </div>

      <div className="px-2 py-2 bg-pink-100 mt-2">
        <div className="flex items-center justify-center">
          <div className="mx-auto  max-w-2xl">
            <ul className='-mb-px flex items-center justify-center p-0 gap-2'>
              <li className='mr-1'>
                <NavLink
                  to={`/shop/ads/adsprofiles/orders`}
                  className={({ isActive }) =>
                    `inline-block rounded-t-lg border-b-2 text-black no-underline ${isActive
                      ? 'border-blue-600  text-blue-600'
                      : 'border-transparent  hover:border-gray-300 hover:text-gray-600'
                    } `
                  }
                  aria-current='page'
                >
                  Orders
                </NavLink>

              </li>
              <li className='mr-1 '>
                <NavLink
                  end
                  to={`/shop/ads/adsprofiles/history`}
                  className={({ isActive }) => {
                    return `inline-block rounded-t-lg border-b-2 text-black no-underline ${isActive
                      ? 'border-blue-600  text-blue-600'
                      : 'border-transparent  hover:border-gray-300 hover:text-gray-600'
                      }`
                  }}
                >
                  Lịch sử
                </NavLink>
              </li>
            </ul>
            {slug_2 == 'history' ? (<><History /></>)
              : (<>
                <div className="border-b border-gray-200 text-center font-medium text-gray-500 bg-slate-100 mt-0 py-1 px-2 rounded-sm">
                  <div className="-mb-px mt-0  p-0 gap-2">
                    {!showoption ?
                      (<><div className="flex justify-center items-center">
                        <RingLoader size={80} color="#0000ff" />  </div></>)
                      : (<>
                        <form className="mx-auto add-form">
                          <div className="form-control">
                            <label>Chọn kiểu quảng cáo</label>
                            <Select
                              classNamePrefix="Chọn 1 lựa chọn"
                              options={options}
                              onChange={handleChange1}
                              value={selectedOption}
                            />
                            <label>Chọn dịch vụ quảng cáo</label>
                            <Select
                              classNamePrefix="Chọn 1 lựa chọn"
                              onFocus={handleFocus2}
                              options={services}
                              menuIsOpen={isOpen}
                              onBlur={handleBlur2}
                              onMenuOpen={handleMenuOpen2}
                              onChange={handleChange2}
                              isDisabled={false}
                              isLoading={false}
                              isClearable={true}
                              isRtl={false}
                              isSearchable={false}
                            />
                          </div>
                          {datatype && (
                            <>
                              <>
                                {datatype.category == 'telegram_ads'
                                  ?
                                  (<>
                                    <label>Chọn quảng cáo nhóm</label>
                                    <Select
                                      classNamePrefix="Chọn 1 lựa chọn"
                                      onFocus={handleFocus3}
                                      options={groups}
                                      menuIsOpen={isOpen2}
                                      onBlur={handleBlur3}
                                      onMenuOpen={handleMenuOpen3}
                                      onChange={handleChange3}
                                      isDisabled={false}
                                      isLoading={false}
                                      isClearable={true}
                                      isRtl={false}
                                      isSearchable={false}
                                    />
                                  </>)
                                  : null}
                              </>
                              <div className="text-lg "> Phí: {datatype2.money} Coins</div>
                              <label className="text-lg "> {datatype.content} </label>
                              {datatype.type != "shorts" && (
                                <>
                                  <div className="text-xs mt-0 mb-0"> Rate: {datatype.money} Coins / view</div>
                                  {iduser && type == 'store' && (<>
                                    <label className="text-xs mt-0 mb-0"> Nhập số Views Bạn muốn quảng cáo</label>
                                  </>)}
                                  <div className="input-group flex-nowrap">
                                    <span
                                      className="input-group-text"
                                      id="addon-wrapping"
                                    >
                                      <RiPencilLine />
                                    </span>
                                    <input
                                      type="number"
                                      className="mt-1 form-control"
                                      placeholder='Nhập số Views Bạn muốn quảng cáo'
                                      aria-label="inputlienket"
                                      value={inputlienket}
                                      name="inputlienket"
                                      aria-describedby="addon-wrapping"
                                      onChange={(e) => setinputlienket(e.target.value)}
                                    />
                                  </div>


                                  {iduser && type == 'store' && (<>
                                    <label className="text-xs mt-0 mb-0"> Nhập id gian hàng </label>
                                    <div className="input-group flex-nowrap mt-0">
                                      <span
                                        className="input-group-text "
                                        id="addon-wrapping"
                                      >
                                        <RiPencilLine />
                                      </span><input
                                        type="text"
                                        className="mt-1 form-control"
                                        placeholder='Xem id gian hàng ở dưới'
                                        aria-label="inputlienket"
                                        value={code_store}
                                        name="inputlienket"
                                        aria-describedby="addon-wrapping"
                                        onChange={(e) => setcode_store(e.target.value)}
                                      />  </div>
                                    <label className="text-xs mt-0 mb-0"> Liên kết mua hàng mới </label>
                                    <div className="input-group flex-nowrap mt-0">
                                      <span
                                        className="input-group-text "
                                        id="addon-wrapping"
                                      >
                                        <RiPencilLine />
                                      </span><input
                                        type="text"
                                        className="mt-1 form-control"
                                        placeholder='vd: https://hust.media'
                                        aria-label="inputlienket"
                                        value={urlmuahang}
                                        name="inputlienket"
                                        aria-describedby="addon-wrapping"
                                        onChange={(e) => seturlmuahang(e.target.value)}
                                      />  </div></>)}

                                </>
                              )}

                            </>
                          )}
                          {datatype.type != "shorts" && (
                            <>
                              Ứng dụng hiện tại đã thu hút hơn 300 nghìn thành viên,
                              góp phần mang đến hàng ngàn khách hàng mới cho quý
                              khách và tăng cường sự tin cậy đối với cửa hàng của
                              mình.
                            </>
                          )}
                          <button
                            disabled={nutxuly == 1}
                            onClick={handleSubmit}
                            className="mt-2 flex break-inside bg-purple-400 hover:bg-purple-300 rounded-3xl px-8 py-2 mb-3 w-full dark:bg-slate-800 dark:text-white"
                          >
                            <div className="flex items-center justify-between flex-1">
                              {nutxuly == 1 && (
                                <div className="spinner-border" role="status"></div>
                              )}

                              <span className="text-lg font-medium text-white">
                                {nutorder}{" "}
                              </span>
                              <div className="text-xl">
                                        {'\u27A4'}
                                    </div>
                            </div>
                          </button>
                        </form>
                      </>)}

                  </div>
                </div>
              </>)}
            {iduser && type == 'store' && (<Products iduser={iduser} />)}
          </div>
        </div>
      </div>
    </>
  );
};

export default Adsprofiles;
